import { useEffect, useState } from 'react';

const getMatches = breakpoint => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < breakpoint;
};

const useIsMobile = breakpoint => {
  const [isMobile, setIsMobile] = useState(() => getMatches(breakpoint));

  useEffect(() => {
    const onResize = () => setIsMobile(getMatches(breakpoint));
    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
